import axios from 'axios';
import apiConfig from '../shared/config/api.config';

export default function hotelConfRequest(hotelId, isKiosk, lang, enableCache) {
  const {
    host,
    URIs: { hotelConf },
  } = apiConfig;

  const uri =
    `${host}${hotelConf}?lang=${lang}&isKiosk=${isKiosk}&enableCache=${enableCache}`.replace(
      ':hotelId',
      hotelId
    );

  return axios.get(uri).then(res => {
    return res.data;
  });
}
